export const APIPATH_REPORTING = {
    empDemographSummary: "/reporting/api/employee-demograph-summary/",
  };
